import { render, staticRenderFns } from "./SimonModule.vue?vue&type=template&id=f770723a&scoped=true&"
import script from "./SimonModule.vue?vue&type=script&lang=js&"
export * from "./SimonModule.vue?vue&type=script&lang=js&"
import style0 from "./SimonModule.vue?vue&type=style&index=0&id=f770723a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f770723a",
  null
  
)

export default component.exports